<template>
  <div class="form-group">
    <label for="dialCode">{{ $t('dialCode') }}</label>
    <div>
      <span class="add">+</span>
      <input type="text" 
        name="dialCode" 
        id="dialCode"
        v-model.number.trim="dialCode"
        v-validate="'required|numeric'"
        @focus="inputBlur = false" @blur="inputBlur = true"
        :placeholder="$t('dialCode')"
        :class="{'danger-border': inputBlur && codeHasError}"
        @input="dialCodeChange"
        @propertychange="dialCodeChange">
    </div>
    <p class="error-info">
      <span v-if="inputBlur && validateError">{{ errors.first('dialCode') }}</span>
      <span v-if="inputBlur && !validateError && codeContentError">{{ dialCodeErrorMsg }}</span>
    </p>
  </div>
</template>

<script>
  import _ from 'lodash'
  import locales from './lang'
  import data from './callingCode.json'

  export default {
    name: 'dial-code-component',
    data: function () {
      return {
        dialCode: 1,
        inputBlur: true,
        data: data,
        dialCodeErrorMsg: this.$t('dialCodeErrorMsg')
      }
    },
    locales,
    computed: {
      validateError() {
        return this.errors.has('dialCode')
      },
      codeContentError() {
        let index = _.findIndex(this.data, ['dialCode', this.dialCode])
        if (index === -1) {
          return true
        } else {
          return false
        }
      },
      codeHasError() {
        return this.codeContentError
      }
    },
    created: function () {
      this.initDialCode()
    },
    methods: {
      dialCodeChange() {
        if (!this.codeHasError) {
          this.$store.commit('setDialCode', this.dialCode)
        }
      },
      initDialCode() {
        if (this.$store.state.dialCode) {
          this.dialCode = this.$store.state.dialCode
        } else {
          this.$http.get('api/location-info').then((response) => {
            if (response.data.code === 0) {
              this.dialCode = response.data.data.dial_code
            }
          })
        }
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/formstyle";

  .form-group {
    display: inline-block;
    float: left;
    > div {
      margin-top: .08rem;
      position: relative;
      .add {
        position: absolute;
        left: .16rem;
        top: .15rem;
      }
      input {
        height: .54rem;
        line-height: .54rem;
        font-size: 16px;
        border: 1px solid #E0D7E3;
        padding: 0 24px;
        border-radius: 42px;
        &::placeholder {
          color: #ccc;
        }
      }
    }
  }


  @media (max-width: 767px) {
    .form-group > div {
      .add {
        left: .08rem;
        top: .12rem;
      }
      input {
        height: 0.49rem;
        line-height: .49rem;
        font-size: 14px;
        padding: 0 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// IndexMain.vue?e73939ec